<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn dark text color="blue-grey accent-4" v-on="on">
                백업
            </v-btn>
        </template>
        <v-card max-width="500" class="mx-auto">
            <v-card-title class="my-5">
                <h4 class="title blue-grey--text text--accent-4">백업하기</h4>
            </v-card-title>
            <v-card-text>
                
                
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon @click="formatUsers">mdi-refresh</v-icon></v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
  
</template>

<script>
import db from '@/fb'

export default {
  name: 'Signup',
  data: () => ({
      dialog: false,
      users: [],
      usersDefault: [],
      levelRating: [
        { level: 0, ratingMin: 1900, ratingMedium: 2500, ratingMax: 3000 },
        { level: 1, ratingMin: 1840, ratingMedium: 1870, ratingMax: 1899 },
        { level: 2, ratingMin: 1780, ratingMedium: 1810, ratingMax: 1839 },
        { level: 3, ratingMin: 1720, ratingMedium: 1750, ratingMax: 1779 },
        { level: 4, ratingMin: 1640, ratingMedium: 1680, ratingMax: 1719 },
        { level: 5, ratingMin: 1500, ratingMedium: 1570, ratingMax: 1639 },
        { level: 6, ratingMin: 1300, ratingMedium: 1400, ratingMax: 1499 },
        { level: 7, ratingMin: 1100, ratingMedium: 1200, ratingMax: 1299 },
        { level: 8, ratingMin: 900, ratingMedium: 1000, ratingMax: 1099 },
        { level: 9, ratingMin: 800, ratingMedium: 850, ratingMax: 899 },
        { level: 10, ratingMin: 700, ratingMedium: 750, ratingMax: 799 }
    ],
    levels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  }),
 methods: {
     formatUsers(){
        db.collection('users').get().then(docs => {
            docs.forEach(doc => {
                this.users.push({
                    ...doc.data(),
                    id: doc.id
                })
            })
        }).then(() => {
            this.users.forEach(user => {
                let defaultUser = {};
                defaultUser.id = user.id
                defaultUser.alias = user.alias;
                defaultUser.avatar = user.avatar;
                defaultUser.history = [];
                defaultUser.history[0] = user.history[0];
                defaultUser.id = user.id;
                defaultUser.inGame = false;
                defaultUser.joinedGroups = [];
                user.joinedGroups.forEach(group => {
                    defaultUser.joinedGroups.push({
                        history: [group.history[0]],
                        id: group.id,
                    })
                });
                defaultUser.level = null;
                this.levelRating.forEach(item => {
                    if(user.history[0] == item.ratingMedium){
                        defaultUser.level = item.level
                    }
                })
                defaultUser.loses = 0;
                defaultUser.name = user.name;
                defaultUser.total = user.history[0];
                defaultUser.type = user.type;
                defaultUser.user_id = user.user_id;
                defaultUser.wins = 0;
                this.usersDefault.push(defaultUser);
            })
        }).then(() => {
            this.usersDefault.forEach(user => {
                db.collection('backupUsers').doc(user.id).set(user);
                db.collection('users').doc(user.id).set(user);
            })
        })
     }
}
};
</script>